export default __webpack_public_path__ + "static/media/addWhite.301742f2.svg";